import type { ProtoZoneFinderData } from "@catbento/shared";
import { getLoadedZoneFinderData, loadZoneFinderData } from "../data/zone-finder.js";

export interface ZoneFinderData {
  /** The loaded file, or null until someone has clicked Load (in any Zone Finder). */
  data: ProtoZoneFinderData | null;
  /** Start (or join) the one shared fetch — the Load / Retry button calls this. */
  load: () => Promise<ProtoZoneFinderData>;
}

// Wrapped (not loadZoneFinderData itself) so `onClick={load}` can't pass the click event
// in as the loader's `meta` argument.
const load = () => loadZoneFinderData();

// Phase 02 seam for the Zone Finder dataset — the one opt-in, async dataset. 04m-a: NO
// auto-fetch (the legacy never fetches until the Load button, to keep the page light).
// The loading state is NOT here: as in the legacy, each module keeps its own
// `_zoneLoadState` (idle / loading / error) and re-renders itself when its load settles,
// so only the module that clicked changes; another open Zone Finder picks the data up on
// its next render (it's read synchronously here). No React state needed, so this is a
// plain read — kept as a hook so the Part-2 cutover swaps the source behind one name.
export function useZoneFinderData(): ZoneFinderData {
  return { data: getLoadedZoneFinderData(), load };
}
